module.exports = __webpack_public_path__ + "img/no_ring@2x.8d209401.png";